import { render, staticRenderFns } from "./adminUpdateShop.vue?vue&type=template&id=053d0e1c&scoped=true"
import script from "./adminUpdateShop.vue?vue&type=script&lang=js"
export * from "./adminUpdateShop.vue?vue&type=script&lang=js"
import style0 from "./adminUpdateShop.vue?vue&type=style&index=0&id=053d0e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053d0e1c",
  null
  
)

export default component.exports